module.exports = __webpack_public_path__ + "static/media/new-gifts4me.5bedf3fd.png";